import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import YYImage from "@/pages/design/components/basic/image";
import YYInput from "@/pages/design/components/basic/input";

// import { languages as allLangList } from '@/locales/'

import hmclickoutside from "@/pages/design/directives/clickoutside";
import { mapState } from "vuex";
import { handleHoverColorEnter, handleHoverColorLeave } from "@/pages/design/common/utils";
import { designPublicData, clientKeyWordList, designGetProductList } from '@/services/design';
import alllang from '@/pages/design/locales/alllang';
export default {
  name: "YYHeader",
  i18n: require("./i18n"),
  directives: {
    hmclickoutside: hmclickoutside
  },
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    YYInput: YYInput,
    YYImage: YYImage
  },
  computed: _objectSpread(_objectSpread({}, mapState(["headerData", "shopcartNum"])), mapState({
    imgHost: function imgHost(state) {
      return state.design.imgHost;
    },
    languages: function languages(state) {
      return state.design.langList;
    },
    defaultLangId: function defaultLangId(state) {
      return state.design.langId;
    },
    languageName: function languageName(state) {
      try {
        var arr = state.design.langList.filter(function (item) {
          return item.langId == state.design.langId;
        });
        return arr[0].langTitle;
      } catch (e) {
        return '';
      }
    }
  })),
  data: function data() {
    return {
      navigationTextColor: "",
      navigationBgColor: "",
      logo: "",
      token: "",
      navigationstatus: false,
      //导航菜单是否显示更多
      searchDialogStatus: true,
      searchHistoryList: [],
      //热词列表
      hotWordList: [],
      //语言列表
      // languages: [],
      // languageName: "",
      //导航栏
      navigations: [],
      //全部分类显示开关
      all_categories_visible: false,
      //头部吸顶
      top_visible: false,
      //选择多语言
      languages_visible: false,
      //用户菜单
      user_menu_visible: false,
      //搜索框是否显示
      text_search_visible: false,
      //搜索内容
      text_search: "",
      //更多导航菜单弹窗
      more_visible: false,
      noticeShowStatus: false,
      //公共是否显示状态
      //获取焦点
      focus: false,
      categoriesTop: 138,
      categoriesCanScroll: false,
      categoriesShowFlag: 0,
      //0：导航没有吸顶展开  1：导航吸顶后展开
      offsetHideDistance: 400,
      //吸顶状态下，分类区域隐藏偏移量
      keyword: []
      // defaultLangId: 2,
    };
  },
  created: function created() {
    // this.languages = JSON.parse(window.localStorage.langList);
    // this.languages.sort((a, b) => a.langId - b.langId);
    // this.languageName = this.languages[0].langName;
    //  let defaultLangObj = localStorage.cdefaultLangObj?localStorage.cdefaultLangObj:localStorage.defaultLangObj;
    // if (defaultLangObj) {
    //   defaultLangObj = JSON.parse(defaultLangObj)
    //   this.defaultLangId  = defaultLangObj.langId
    // }else {
    //   this.defaultLangId = 2
    // }

    this.getData();
  },
  watch: {
    token: function token(newName, oldName) {
      if (newName != oldName) {
        this.getCartProductNum();
      }
    },
    focus: function focus(newValue, oldValue) {
      var _this = this;
      if (newValue) {
        document.onkeypress = function (e) {
          if (e.keyCode == 13) {
            _this.search(_this.text_search);
            _this.$router.push({
              name: "productlist",
              query: {
                search: _this.text_search,
                orderType: 1,
                page: 1
              }
            }).then(function () {
              //清除onkeypress事件，输入框失去焦点
              document.onkeypress = null;
              _this.focus = false;
            });
          }
        };
      }
    }
  },
  mounted: function mounted() {
    // document.addEventListener('mouseup', this.handleMouseUp)
    // console.log("mounted header.vue");
    // if (window.localStorage.getItem('searchHistoryList')) {
    //   //searchHistoryList有值才执行接下来的操作
    //   this.searchHistoryList = JSON.parse(window.localStorage.getItem('searchHistoryList'))
    // }
    //
    // window.document.addEventListener('click', this.handleDocumentClick)
    // window.document.addEventListener('touchstart', this.handleDocumentClick)
    // window.document.addEventListener('scroll', this.handleScrollHandler)
    // /* window.addEventListener('resize', this.handleResizeHandler); */
    // this.fetchData().then(this.loadData)
  },
  serverPrefetch: function serverPrefetch() {
    "";
    // return this.fetchData().then(this.loadData);
  },
  beforeDestroy: function beforeDestroy() {
    // window.document.removeEventListener('mouseup', this.handleMouseUp)
    // window.document.removeEventListener("click", this.handleDocumentClick);
    // window.document.removeEventListener("touchstart", this.handleDocumentClick);
    // window.document.removeEventListener("scroll", this.handleScrollHandler);
    /* window.removeEventListener('resize', this.handleResizeHandler); */
  },
  methods: {
    handleHoverColorEnter: handleHoverColorEnter,
    handleHoverColorLeave: handleHoverColorLeave,
    handleItemEnter: function handleItemEnter(name, i) {
      this.oldBorderColor = this.$refs[name][i].style.borderBottomColor;
      this.$refs[name][i].style.borderBottomColor = this.formData.hoverTextColor;
      this.handleHoverColorEnter(this, name, this.formData.hoverTextColor, i);
    },
    handleItemLeave: function handleItemLeave(name, i) {
      this.$refs[name][i].style.borderBottomColor = this.oldBorderColor;
      handleHoverColorLeave(this, name, i);
    },
    handleSearchItemEnter: function handleSearchItemEnter(name, i) {
      this.oldBorderColor = this.$refs[name][i].style.borderColor;
      this.$refs[name][i].style.borderColor = this.formData.hoverTextColor;
      this.handleHoverColorEnter(this, name, this.formData.hoverTextColor, i);
    },
    handleSearchItemLeave: function handleSearchItemLeave(name, i) {
      this.$refs[name][i].style.borderColor = this.oldBorderColor;
      handleHoverColorLeave(this, name, i);
    },
    getData: function getData() {
      var _this2 = this;
      var basicParams = {
        langId: this.defaultLangId,
        clientType: 1
      };
      basicParams['type'] = 1;

      // designPublicData(basicParams)
      //   .then((res) => res.data)
      //   .then((res) => {
      //     this.logo = res.data.host + res.data.logo;
      //     this.languages = res.data.langList;
      //     let arr = this.languages.filter(item => item.langId == res.data.langId)
      //     this.languageName = arr[0].langTitle
      //   });

      // let langList = window.localStorage.langList
      // langList = JSON.parse(langList)
      // if(langList){
      //   this.languages = langList
      //   let item = langList.filter((item) => {
      //     return item.langId == this.defaultLangId
      //   })
      //   if(item&&item.length>0) {
      //     this.languageName = item[0].langName
      //   }
      // }

      clientKeyWordList(basicParams).then(function (res) {
        return res.data;
      }).then(function (res) {
        _this2.hotWordList = res.data;
      });
    },
    handleScrollHandler: function handleScrollHandler(e) {
      var scrollTop = document.documentElement.scrollTop;
      this.top_visible = scrollTop > this.$el.offsetHeight;
      var all_categories = document.querySelector(".all_categories");
      var isVisbile = this.checkVisible(all_categories);
      //如果分类区域不可见，隐藏分类
      if (!isVisbile) {
        this.all_categories_visible = false;
      }
      //如果导航吸顶的情况下，滚动条位置小于显示分类时的位置，说明是向上滚动了滚动条，将分类区域固定显示，否则可以滚动
      if (this.top_visible) {
        var navigatorBottom = 0;
        if (document.querySelector(".top .header_top")) {
          var _navigatorBottom = document.querySelector(".top .header_top").getBoundingClientRect().bottom;
          if (this.noticeShowStatus) {
            var noticeBottom = document.querySelector(".affiche").getBoundingClientRect().bottom;
            var noticeTop = document.querySelector(".affiche").getBoundingClientRect().top;
            _navigatorBottom = _navigatorBottom - (noticeBottom - noticeTop);
          }
        }
        if (scrollTop + navigatorBottom < this.categoriesTop) {
          var _scrollTop = document.documentElement.scrollTop;
          if (this.categoriesShowFlag == 1) {
            console.log("客户与本：", this.categoriesTop - (_scrollTop + navigatorBottom) - this.offsetHideDistance);
            if (this.categoriesTop - (_scrollTop + navigatorBottom) - this.offsetHideDistance > 0) {
              this.all_categories_visible = false;
            } else {
              this.categoriesCanScroll = true;
            }
          }
        } else if (this.categoriesShowFlag == 1) {
          this.categoriesCanScroll = false;
        }
      } else {
        this.categoriesCanScroll = false;
        this.categoriesTop = 138;
      }
    },
    showHideCategories: function showHideCategories() {
      var scrollTop = document.documentElement.scrollTop;
      console.log("展开时的位置", scrollTop);
      if (this.top_visible) {
        this.categoriesShowFlag = 1;
      } else {
        this.categoriesShowFlag = 0;
      }
      //导航是隐藏状态时，显示分类时，将分类区域位置设置为滚动条位置；如果导航是显示状态，分类区域固定在138的位置
      if (!this.all_categories_visible) {
        if (this.top_visible) {
          var navigatorBottom = document.querySelector(".top .header_top").getBoundingClientRect().bottom;
          if (this.noticeShowStatus) {
            var noticeBottom = document.querySelector(".affiche").getBoundingClientRect().bottom;
            var noticeTop = document.querySelector(".affiche").getBoundingClientRect().top;
            navigatorBottom = navigatorBottom - (noticeBottom - noticeTop);
          }
          console.log(navigatorBottom);
          this.categoriesTop = document.documentElement.scrollTop + navigatorBottom;
        } else {
          this.categoriesTop = 138;
        }
      }
      this.all_categories_visible = !this.all_categories_visible;
    },
    checkVisible: function checkVisible(elm) {
      if (!elm) {
        return;
      }
      var rect = elm.getBoundingClientRect();
      //获取当前浏览器的视口高度，不包括工具栏和滚动条
      //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
      var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      //bottom top是相对于视口的左上角位置
      //bottom大于0或者top-视口高度小于0可见
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    },
    setTextSearch: function setTextSearch(content) {
      this.text_search = content;
    },
    clickIconUser: function clickIconUser() {
      /* if (window.localStorage.token) {
       *   this.user_menu_visible = !this.user_menu_visible;
       * } else {
       *   //点击登录成功后，重定向到我的订单
       *   this.$router.push({
       *     name: "login",
       *     query: { redirect: "/account/order" },
       *   });
       *   // this.$router.push({ path: '/account/order'})
       * } */
    },
    searchInputFocus: function searchInputFocus() {
      this.focus = true;
      var self = this;
      if (!self.text_search) {
        self.$nextTick(function () {
          self.searchDialogStatus = true;
        });
      }
    },
    handleOutSide: function handleOutSide() {
      window.console.log('out');
      this.searchDialogStatus = false;
    },
    //去重方法封装
    unique: function unique(arr) {
      return arr.filter(function (item, index, arr) {
        return arr.indexOf(item, 0) === index;
      });
    },
    closeNotice: function closeNotice() {
      // this.$refs.affiche.style.display = 'none';
      this.noticeShowStatus = false;
      window.localStorage.noticeShowStatus = false;
    },
    //搜索
    search: function search(keyword) {
      this.focus = false;
      this.searchDialogStatus = false;
      if (keyword.trim() !== "") {
        this.searchHistoryList.unshift(keyword);
        this.searchHistoryList = this.unique(this.searchHistoryList); //调用unique方法去重
        if (this.searchHistoryList.length > 8) {
          //最多保存8条
          this.searchHistoryList = this.searchHistoryList.slice(0, 8);
        }
        window.localStorage.setItem("searchHistoryList", JSON.stringify(this.searchHistoryList)); //存localStorage
        this.text_search = keyword.trim();
      }
    },
    //点击搜索按钮
    clickSearchBtn: function clickSearchBtn() {
      var self = this;
      self.text_search_visible = true;
      self.$nextTick(function () {
        self.$refs.search.focus();
      });
    },
    //删除搜索列表记录
    deleteSearchHistoryList: function deleteSearchHistoryList() {
      window.localStorage.removeItem("searchHistoryList");
      this.searchHistoryList = [];
    },
    //单个删除搜索记录
    deleteSearchHistory: function deleteSearchHistory(index) {
      var self = this;
      self.searchHistoryList.splice(index, 1);
      window.localStorage.setItem("searchHistoryList", JSON.stringify(self.searchHistoryList)); //存localStorage
    },
    fetchData: function fetchData() {
      var data = this.$store.dispatch("FETCH_HEADERDATA");
      return data;
    },
    loadData: function loadData() {
      var self = this;
      var data = this.headerData.headerInfo; //头部信息
      console.log("首赠logo", data.host, data.logo);
      this.$nextTick(function () {
        self.logo = data.host + data.logo;
      });
      // if (!data) {
      //   return
      // }
      //
      //收货地址中详细地址的正则表达式，防止输入特殊字符
      self.$store.state.reg = data.addressReg;
      if (this.headerData.headerInfo.zz0005) {
        console.log("加载谷歌统计");
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
          window.dataLayer.push(arguments);
        };
        window.gtag("js", new Date());
        window.gtag("config", process.env.config.googleKey);
        console.log("执行谷歌统计", this.$route.path);
        window.gtag("config", process.env.config.googleKey, {
          page_path: this.$route.path
        });
      }
      self.$store.state.leftCurrencySymbol = data.leftSymbol;
      self.$store.state.rightCurrencySymbol = data.rightSymbol;
      window.localStorage.setItem("storeName", data.storeName);
      if (data.noticeInfo) {
        if (!window.localStorage.noticeLastUpdateTime) {
          window.localStorage.setItem("noticeLastUpdateTime", data.noticeInfo.lastUpdateTime);
          self.noticeShowStatus = true;
          window.localStorage.setItem("noticeShowStatus", true);
        } else {
          if (window.localStorage.noticeLastUpdateTime != data.noticeInfo.lastUpdateTime || window.localStorage.noticeShowStatus == "true") {
            self.noticeShowStatus = true;
            window.localStorage.setItem("noticeShowStatus", true);
          }
        }
      }
      if (data.navigatorInfo.length > 10) {
        self.navigationstatus = true;
      }
      var _iterator = _createForOfIteratorHelper(data.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          item.value = allLangList[item.langId];
          if (window.localStorage.languageCode == item.value) {
            self.languageName = item.langTitle;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.languages = data.langList;
      self.navigationBgColor = data.navigatorCss.bgColor;
      self.navigationTextColor = data.navigatorCss.textColor;
      self.ico = data.host + data.ico;
      //修改网页标题左侧ico
      //有可能到这里的时候，window.onload的回调已经执行完毕了
      if (document.getElementsByTagName("head")) {
        var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = data.host + data.ico + "?num=" + Math.random();
        document.getElementsByTagName("head")[0].appendChild(link);
      } else {
        window.onload = function () {
          var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = data.host + data.ico + "?num=" + Math.random();
          document.getElementsByTagName("head")[0].appendChild(link);
        };
      }
    },
    //选择语言
    languageChang: function languageChang(item) {
      var _this3 = this;
      //更新客户表语言id

      //
      // this.languageName = item.langTitle;
      //

      this.$store.dispatch('design/page_save').then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var cdefaultLangObj, lang, arr, goodsCom, _iterator2, _step2, g, _res, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!(res.data.code === 200)) {
                  _context.n = 9;
                  break;
                }
                _this3.$store.state.design.loading = true;
                _this3.$store.dispatch('design/form_close');
                cdefaultLangObj = {
                  langId: item.langId
                };
                localStorage.setItem('cdefaultLangObj', JSON.stringify(cdefaultLangObj));
                _this3.$store.state.design.langId = item.langId;
                lang = alllang[item.langId];
                _this3.$store.state.design.langCode = lang;
                localStorage.setItem('langCode', lang);
                arr = _this3.$store.state.design.components;
                _this3.$store.state.design.components = [];
                goodsCom = arr.filter(function (item) {
                  return item.name === 'Goodslist';
                });
                _iterator2 = _createForOfIteratorHelper(goodsCom);
                _context.p = 1;
                _iterator2.s();
              case 2:
                if ((_step2 = _iterator2.n()).done) {
                  _context.n = 5;
                  break;
                }
                g = _step2.value;
                _context.n = 3;
                return designGetProductList({
                  moduleId: g.id,
                  langId: item.langId,
                  plate: 2,
                  clentType: 1
                });
              case 3:
                _res = _context.v;
                g.componentValue.productList = _res.data.data.productList;
              case 4:
                _context.n = 2;
                break;
              case 5:
                _context.n = 7;
                break;
              case 6:
                _context.p = 6;
                _t = _context.v;
                _iterator2.e(_t);
              case 7:
                _context.p = 7;
                _iterator2.f();
                return _context.f(7);
              case 8:
                _this3.$nextTick(function () {
                  _this3.$store.state.design.components = arr;
                  _this3.$store.state.design.loading = false;
                });
              case 9:
                return _context.a(2);
            }
          }, _callee, null, [[1, 6, 7, 8]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());

      /* updateCustomerLanguage(window.localStorage.langId).then((res) => {
       *   if (res.data.code == 200) {
       *     // loadLanguageAsync(item.value)
       *     this.languageName = item.langTitle;
       *     this.$store.commit("SET_LANG", { lang: item.value });
       *     // window.localStorage.langId = item.langId;
       *     // window.localStorage.languageCode = item.value;
       *   }
       * }); */
    },
    handleDocumentClick: function handleDocumentClick(e) {
      var self = this;
      //全部分类
      if (!this.$refs.all_categories.contains(e.target) && !this.$refs.all_product.contains(e.target) && !this.$refs.all_product2.contains(e.target)) {
        this.all_categories_visible = false;
      }
      //多语言
      if (!this.$refs.languages.contains(e.target)) {
        this.languages_visible = false;
      }
      //用户
      if (!this.$refs.user_menu.contains(e.target)) {
        this.user_menu_visible = false;
      }
      //搜索弹窗
      if (!self.$refs.search_box.contains(e.target) && !self.$refs.search_icon.contains(e.target)) {
        self.searchDialogStatus = false;
      }

      //更多导航菜单
      if (this.$refs.moreNavigations && !this.$refs.moreNavigations.contains(e.target)) {
        this.more_visible = false;
      }
    },
    //退出
    quit: function (_quit) {
      function quit() {
        return _quit.apply(this, arguments);
      }
      quit.toString = function () {
        return _quit.toString();
      };
      return quit;
    }(function () {
      var _this4 = this;
      quit().then(function (res) {
        if (res.data.code == 200) {
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("nickName");
          _this4.$store.state.token = "";
          YYMessage(_this4.$t("memberCenter.logoutSuccess"));
          _this4.$store.commit("updateShopcartNum", {
            shopcartNum: 0
          });
          _this4.$router.push({
            path: "/"
          });
        }
      });
    }) //监听浏览器宽度 修改导航菜单是否出现更多
    /* handleResizeHandler() {
        const self = this;
        let screenWidth = window.screenWidth || document.body.clientWidth;
        if (this.navigations.length > 10) {
            self.navigationstatus = true;
        }  else if( screenWidth < 1500 && this.navigations.length > 10){
            self.navigationstatus = true;
        }  else {
            self.navigationstatus = false;
        }
    } */
  }
};